import { createSelectorFunctions } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';
import { createPlayerManagerStoreState } from '../shared/store';
export function createPlayerManagerStore(extraStateCreator) {
    const playerStore = create((set, get) => ({
        ...createPlayerManagerStoreState(set, get),
        ...(extraStateCreator ? extraStateCreator(set, get) : {}),
    }));
    return createSelectorFunctions(playerStore);
}
export { registerPlayerManagerEvents } from '../shared/store';
